import { drawerActionTypes } from '../../config/constant'

const openAssetsDrawer = () => {
    return {
        type: drawerActionTypes.OPEN_ASSETS,
        payload: {
            assetsDrawerState: true,
            assetsButtonStyle: 'DrawerButton DrawerOpenedButtonLeft',
        },
    }
}

const closeAssetsDrawer = () => {
    return {
        type: drawerActionTypes.CLOSE_ASSETS,
        payload: {
            assetsDrawerState: false,
            assetsButtonStyle: 'DrawerButton DrawerClosedButtonLeft',
        },
    }
}

const openDetectionsDrawer = () => {
    return {
        type: drawerActionTypes.OPEN_DETECTIONS,
        payload: {
            detectionsDrawerState: true,
            detectionsButtonStyle: 'DrawerButton DrawerOpenedButtonRight',
        },
    }
}

const closeDetectionsDrawer = () => {
    return {
        type: drawerActionTypes.CLOSE_DETECTIONS,
        payload: {
            detectionsDrawerState: false,
            detectionsButtonStyle: 'DrawerButton DrawerClosedButtonRight',
        },
    }
}

export default {
    openAssetsDrawer,
    closeAssetsDrawer,
    openDetectionsDrawer,
    closeDetectionsDrawer,
}
